import { Box, Button, useMediaQuery } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CheckIcon from "@material-ui/icons/Check";
import { Link } from "react-router-dom";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useSelectAddOnsExtraServicesStyles } from "./AddOnItem.styles";
import { paymentTypeTitle } from "../../../../app/utils";
import { addSubscriptionQuote } from "../../../../store/QuoteSlice";
import { eventAnalytic } from "../../../../app/analytics";
import { ProductSubscription, getFirstImage } from "../../../../api/Product/ProductSubscriptionApi";
import { mapProductSubscriptionToForm } from "../../../../api/QuoteSubscription/QuoteSubscriptionApi";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

export const SubscriptionItem = ({
  item,
  quoteId,
  selected,
  isFirst,
  firstBorderTop
}: {
  item: ProductSubscription;
  quoteId: string;
  selected: boolean;
  isFirst: boolean;
  firstBorderTop: boolean;
}) => {
  const { isMoreThanSm } = useBreakpoint();
  const matchesSmallMobile = useMediaQuery("(max-width:376px)");
  const classes = useSelectAddOnsExtraServicesStyles();
  const dispatch = useDispatch();

  const onAddSubscription = (subscription: ProductSubscription) => {
    eventAnalytic.record(subscription);
    dispatch(addSubscriptionQuote(quoteId, mapProductSubscriptionToForm(subscription)));
    toast.success(subscription.name + " has been added");
  };

  return (
    <Box display="flex" pt="41px" borderTop={!isFirst || firstBorderTop ? "solid 1px #efefef" : "none"}>
      <Box>
        <Box
          border={"solid 1px #dfdfdf"}
          mb={5}
          mr={isMoreThanSm ? 5 : "18px"}
          width={isMoreThanSm ? 137 : 80}
          height={isMoreThanSm ? 213 : 124}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <img
            width={"100%"}
            height={"100%"}
            style={{ objectFit: "cover" }}
            alt={item.name}
            src={getFirstImage(item)?.url}
          />
        </Box>
      </Box>
      <Box>
        <Box className={classes.title} mb="20px">
          {item.name}
        </Box>
        <Box className={classes.content} mb={isMoreThanSm ? "30px" : "20px"}>
          <span className="description">{item.highLevelDescription} </span>
        </Box>
        <Box
          display="flex"
          alignItems={"center"}
          flexWrap={matchesSmallMobile ? "wrap" : "nowrap"}
          justifyContent={!isMoreThanSm ? "space-between" : ""}
          mb={isMoreThanSm ? "32px" : 1}
        >
          <Box className={classes.priceSubscription} marginBottom={matchesSmallMobile ? "15px" : 0}>
            <span className="from">from</span>
            <Box className="price">
              <PriceFormat value={item.prices[0].price} />
              &nbsp;{paymentTypeTitle(item.prices[0].paymentType, false)}
            </Box>
          </Box>
          <Button className={`${classes.add}`} onClick={() => onAddSubscription(item)} disabled={selected}>
            {selected && <CheckIcon />}
            {selected ? "Added" : "Add"}
          </Button>
        </Box>
        <Box className={classes.benefitsStr}>Your Swyft Boiler Servicing package includes all the benefits of</Box>
        <Box className={classes.benefits} ml={-3}>
          <ul>
            {item.highlights?.map((highlight, idx) => (
              <li key={idx}>
                {highlight}
                {(item.highlights?.length as number) - 1 === idx ? <Link to="/protect">More Details</Link> : null}
              </li>
            ))}
          </ul>
        </Box>
      </Box>
    </Box>
  );
};
